import React from "react";
import PropTypes from "prop-types";

import HorizontalRuler from "./HorizontalRuler";
import VerticalRuler from "./VerticalRuler";


export default function RulersOverlay({
  horizontal,
  vertical,
  className = "",
}) {
  return (
    <div
      className={[
        "studio-rulers-overlay",
        className,
      ].filter(Boolean).join(" ")}
    >
      <div className="studio-rulers-overlay__corner" />

      <HorizontalRuler
        configuration={horizontal}
      />

      <VerticalRuler
        configuration={vertical}
      />
    </div>
  );
}


RulersOverlay.propTypes = {
  horizontal: PropTypes.object.isRequired,
  vertical: PropTypes.object.isRequired,
  className: PropTypes.string,
};
